export default __webpack_public_path__ + "static/media/services4.e40f2f78.jpg";